import { DefaultFilterComponent, DefaultFormComponent, FormOptions } from '@hutsix/ngxh6';
import { UserFormComponent } from '../modules/_shared/components/forms/custom-forms/user-form/user-form.component';
import forms_conf from '../_generated/ext_config/forms.json';
import { IncidentFormComponent } from '../modules/csp/components/forms/incident-form/incident-form.component';
import { ScheduledServiceFormComponent } from '../modules/csp/components/forms/scheduled-service-form/scheduled-service-form.component';
import { CheckInLocationFormComponent } from '../modules/csp/components/forms/check-in-location-form/check-in-location-form.component';

export const custom_filters: { [key: string]: any } = {
  DefaultFilterComponent: DefaultFilterComponent,
};

export const custom_forms: { [key: string]: any } = {
  DefaultFormEmbedComponent: DefaultFormComponent,
  UserFormComponent: UserFormComponent,
  IncidentFormComponent: IncidentFormComponent,
  ScheduledServiceFormComponent: ScheduledServiceFormComponent,
  CheckInLocationFormComponent: CheckInLocationFormComponent,
};

/** Override generated form values here */
const forms_conf_overrides: Override = {
  incident: {
    object_name: 'Incident',
    object_class: 'App\\Entity\\CSP\\Incident\\Incident',
    api_get: '/api/csp/incidents/form',
    allow_edits: true,
    allow_archive: true,
    offline_create: true,
    offline_edit: true,
    cache_strategy: 'refresh',
    offline_endpoint: '/api/v1/csp/incidents',
    success_route: 'csp/incidents',
    create_string: 'Log Incident',
    edit_string: 'Log Incident',
    edit_success_string: 'Incident Saved',
    create_success_string: 'Incident Saved',
    component: 'IncidentFormComponent',
    autosave: false,
  },
  action: {
    object_name: 'Action',
    object_class: 'App\\Entity\\CSP\\Action',
    api_get: '/api/csp/action/form',
    allow_edits: true,
    allow_archive: true,
    success_route: 'csp/config',
    modal_size: 'md',
    modal_display: 'vertical',
  },
  reason: {
    object_name: 'Incident Reason',
    object_class: 'App\\Entity\\CSP\\Reason',
    api_get: '/api/csp/reason/form',
    allow_edits: true,
    allow_archive: true,
    success_route: 'csp/config',
    modal_size: 'md',
    modal_display: 'vertical',
  },
  observation: {
    object_name: 'Observation',
    object_class: 'App\\Entity\\CSP\\Observation',
    api_get: '/api/csp/observation/form',
    allow_edits: true,
    allow_archive: true,
    success_route: 'csp/config',
    modal_size: 'md',
    modal_display: 'vertical',
  },
  area_patrolled: {
    object_name: 'Area Patrolled',
    object_class: 'App\\Entity\\CSP\\AreaPatrolled',
    api_get: '/api/csp/patrolled_areas/form',
    allow_edits: true,
    allow_archive: true,
    success_route: 'csp/config',
    modal_size: 'md',
    modal_display: 'vertical',
  },
  activity_conducted: {
    object_name: 'Activities Conducted',
    object_class: 'App\\Entity\\CSP\\ActivityConducted',
    api_get: '/api/csp/activity_conducted/form',
    allow_edits: true,
    allow_archive: true,
    success_route: 'csp/config',
    modal_size: 'md',
    modal_display: 'vertical',
  },
  contribution: {
    object_name: 'Contributing Factor',
    object_class: 'App\\Entity\\CSP\\Contribution',
    api_get: '/api/csp/contribution/form',
    allow_edits: true,
    allow_archive: true,
    success_route: 'csp/config',
    modal_size: 'md',
  },
  patrol_comment: {
    object_name: 'Patrol Comments',
    object_class: 'App\\Entity\\CSP\\PatrolComment',
    api_get: '/api/csp/patrol_comments/form',
    allow_edits: true,
    allow_archive: true,
    success_route: 'csp/config',
    modal_size: 'md',
  },
  service_type: {
    object_name: 'Service Type',
    object_class: 'App\\Entity\\CSP\\ServiceType',
    api_get: '/api/csp/service-type/form',
    allow_edits: true,
    allow_archive: true,
    success_route: 'csp/config',
    modal_size: 'md',
    modal_display: 'vertical',
  },
  staff: {
    object_name: 'Staff',
    object_class: 'App\\Entity\\CSP\\Staff',
    api_get: '/api/user/csp-staff/form',
    allow_edits: true,
    allow_archive: true,
    offline_create: true,
    offline_edit: true,
    cache_strategy: 'refresh',
    offline_endpoint: '/api/v1/csp/users',
    success_route: 'csp/staff',
    slug: 'csp_staff',
  },
  service_delivery: {
    object_name: 'Service Delivery',
    object_class: 'App\\Entity\\CSP\\Service\\ServiceDelivery',
    api_get: '/api/csp/service_delivery/form',
    allow_edits: true,
    allow_archive: true,
    offline_create: true,
    offline_edit: true,
    cache_strategy: 'refresh',
    offline_endpoint: '/api/v1/csp/service_deliveries',
    success_route: 'csp/service-deliveries',
    display: 'vertical',
    autosave: false,
  },
  scheduled_service: {
    object_name: 'Service Delivery',
    object_class: 'App\\Entity\\CSP\\Service\\ServiceDelivery',
    api_get: '/api/csp/scheduled_service/form',
    allow_edits: true,
    allow_archive: true,
    offline_create: true,
    offline_edit: true,
    cache_strategy: 'refresh',
    offline_endpoint: '/api/v1/csp/service_deliveries',
    success_route: 'csp/service-deliveries',
    display: 'vertical',
    component: 'ScheduledServiceFormComponent',
  },
};

/** Create custom forms or override generated forms here */
const forms = {};

/**
 *
 * You shouldn't need to change anything below
 *
 */
export function getFormsConfig(): { [key: string]: FormOptions } {
  const f = JSON.parse(JSON.stringify(forms_conf));
  for (const [k, v] of Object.entries(forms_conf_overrides)) {
    if (f[k]) {
      f[k] = Object.assign(forms_conf[k], v);
    } else {
      console.warn(`Attempt to override generated form failed. Key '${k}' doesn't exist`);
    }
  }
  return { ...f, ...forms };
}

export function getForm(slug: FormKeys): FormOptions {
  return getFormsConfig()[slug];
}

declare global {
  type FormKeys = keyof typeof forms | keyof typeof forms_conf;
}

type Override = { [Property in keyof Partial<typeof forms_conf>]: Partial<FormOptions> };
